import { render, staticRenderFns } from "./newsletter-view-page.vue?vue&type=template&id=6cb470a4&"
import script from "./newsletter-view-page.vue?vue&type=script&lang=js&"
export * from "./newsletter-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports